module.exports = __webpack_public_path__ + "media/media/cases/case-2-8c0fcd7694e26897cecc1e4154a74457.jpg";